import React from "react";

export default function StripeReturnPage() {
  const styles = {
    body: {
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
      padding: 40,
      backgroundColor: "#f9f9f9",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      maxWidth: 400,
      margin: "auto",
    },
    title: {
      fontSize: 24,
      marginBottom: 20,
    },
    text: {
      fontSize: 16,
      marginBottom: 20,
      color: "#333",
    },
    button: {
      backgroundColor: "#6772E5",
      color: "white",
      border: "none",
      padding: "14px 22px",
      borderRadius: 6,
      fontSize: 16,
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h2 style={styles.title}>Returning to NimbleBash</h2>
        <p style={styles.text}>
          Your payment was processed. You can now close this browser window and return to the app.
        </p>
      </div>
    </div>
  );
}